/**
 * @generated SignedSource<<33129ba978fb1cc2ba327ea45db4c082>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_childIssuesPanelData$data = {
  readonly jira: {
    readonly issueSearch: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly cursor: string;
      } | null | undefined> | null | undefined;
      readonly issueSearchError: {
        readonly __typename: string;
      } | null | undefined;
      readonly pageInfo: {
        readonly endCursor: string | null | undefined;
        readonly startCursor: string | null | undefined;
      };
      readonly totalCount: number | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"NativeIssueTableWithSelectedIssuesProvider_issues">;
    } | null | undefined;
  };
  readonly " $fragmentType": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_childIssuesPanelData";
};
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_childIssuesPanelData$key = {
  readonly " $data"?: ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_childIssuesPanelData$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_childIssuesPanelData">;
};

import ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_IssueSearchPaginationQuery_graphql from './ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_IssueSearchPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "jira",
  "issueSearch"
],
v1 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "before"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetsInput"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "issueSearchInput"
    },
    {
      "kind": "RootArgument",
      "name": "last"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "bidirectional",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": {
          "count": "last",
          "cursor": "before"
        },
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_IssueSearchPaginationQuery_graphql
    }
  },
  "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_childIssuesPanelData",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "issueSearch",
            "args": [
              {
                "kind": "Variable",
                "name": "issueSearchInput",
                "variableName": "issueSearchInput"
              }
            ],
            "concreteType": "JiraIssueConnection",
            "kind": "LinkedField",
            "name": "__ChildIssuesPanelIssueSearchPagination__issueSearch_connection",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  },
                  {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v1/*: any*/)
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "startCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasPreviousPage"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "totalCount"
              },
              {
                "kind": "LinkedField",
                "name": "issueSearchError",
                "plural": false,
                "selections": (v1/*: any*/)
              },
              {
                "kind": "FragmentSpread",
                "name": "NativeIssueTableWithSelectedIssuesProvider_issues"
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__id"
                  }
                ]
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "jira"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "7acd999bfc296fc3a31013de60123402";

export default node;
